import angular from "angular";
import cgNotify from "@cgross/angular-notify";
import angularUIB from "angular-ui-bootstrap";
import angularMoment from "angular-moment";
import routeTrainsCars from "../route-trains-cars/route-trains-cars";
import routeCard from "../route-card/route-card";
import core from "../../core/core.module";
import passengerForm from "../passengerForm/passengerForm";
import trainRouteService from "../trainRoutesService/trainRoutesService";
import finalOrder from "../finalOrder/finalOrder";
import duplicatedTickets from "../duplicated-tickets/duplicated-tickets";
import notElRegRoutes from "../not-el-reg-routes/not-el-reg-routes";

let mod = angular
    .module('bookingModule.bookingModule', [
        cgNotify,
        angularMoment,
        core,
        routeTrainsCars,
        routeCard,
        trainRouteService,
        passengerForm,
        finalOrder,
        angularUIB,
        duplicatedTickets,
        notElRegRoutes
    ])
    .component('bookingModule', {
        template: require('./booking-module.html'),
        controller: [
            '$http',
            '$timeout',
            '$rootScope',
            '$q',
            '$interval',
            'moment',
            'notify',
            'trainRoutesService',
            'Auth',
            'notifier',
            '$uibModal',
            '$anchorScroll',
            '$location',
            controller
        ],
        bindings: {
            routeType: '@',
            routes: '<',
            adults: '<',
            children: '<',
            queryString: '@',
            docTypes: '<',
            text1: '@',
            text2: '@',
            enableClientsModule: '<',
            fields: '<',
            clientsCount: '<',
        },
    });

function controller(
    $http,
    $timeout,
    $rootScope,
    $q,
    $interval,
    moment,
    notify,
    trainRoutesService,
    Auth,
    notifier,
    $uibModal,
    $anchorScroll,
    $location
) {

    let $ctrl = this;

    window.bookingModule = $ctrl;

    $ctrl.client = null;
    $ctrl.authUser = null;

    $ctrl.passengers = [];

    $ctrl.paymentType = null;

    $ctrl.clientFieldValues = {};

    $ctrl.$onInit = function () {
        $ctrl.getCitizenshipList().then(() => {
            $ctrl.openFirstStep(0);
        });
        $http
            .get('/auth-user').then(res => {
            $ctrl.authUser = res.data
            if ($ctrl.authUser.organization_id === 89) {
                $ctrl.paymentType = 'non-cash';
            }
        });

    };

    $ctrl.getCitizenshipList = function () {
        const d = $q.defer();

        $http
            .get('/data/get-citizenship-list')
            .then(res => {
                $ctrl.citizenshipList = res.data;
                d.resolve();
            })
            .catch(err => {
                d.reject();
            });

        return d.promise;
    };

    $ctrl.openFirstStep = function (routeInd) {
        $ctrl.step = 1;
        $ctrl.activeRouteInd = routeInd !== undefined ? routeInd : $ctrl.routes.length - 1;
    };

    $ctrl.selectRoute = function (ind) {
        $ctrl.activeRouteInd = ind;
    };

    $ctrl.changePassengersCount = function (adults, children) {
        $ctrl.adults = adults;
        $ctrl.children = children;
        for (let i = 0; i < $ctrl.routes.length; i++) {
            $ctrl.routes[i].allocationTop = null;
            $ctrl.routes[i].allocationBottom = null;
            $ctrl.routes[i].seatsComp = null;
        }
    };

    $ctrl.setRouteData = function (data) {
        let route = $ctrl.routes[$ctrl.activeRouteInd];
        route.train = data.train;
        route.carGroup = data.carGroup;
        route.car = data.car;
        route.seatsStart = data.seatsStart;
        route.seatsEnd = data.seatsEnd;
        route.seatsCount = data.seatsCount;
        route.topSeatsCount = data.topSeatsCount;
        route.bottomSeatsCount = data.bottomSeatsCount;
        route.allocationTop = null;
        route.allocationBottom = null;
        route.seatsComp = null;
        route.isComplete =
            (route.car && route.car.hasSeatNumbers && route.seatsCount) ||
            (route.car && !route.car.hasSeatNumbers);
    };

    $ctrl.routeSelected = function () {
        if ($ctrl.isEditing) {
            if (validateRoutes()) {
                openSecondStep();
            }
        } else {
            if ($ctrl.activeRouteInd + 1 < $ctrl.routes.length) {
                $ctrl.activeRouteInd++;
            } else {
                if (validateRoutes()) {
                    openSecondStep();
                }
            }
        }
    };

    function validateRoutes() {
        for (let i = 0; i < $ctrl.routes.length; i++) {
            if (!$ctrl.routes[i].train) {
                nf('Выберите поезд для маршрута №' + (i + 1));
                return false;
            }
            if (!$ctrl.routes[i].car) {
                nf('Выберите вагон для маршрута №' + (i + 1));
                return false;
            }
            if ($ctrl.routes[i].car.hasSeatNumbers) {
                if (!$ctrl.routes[i].seatsStart) {
                    nf('Выберите места для маршрута №' + (i + 1));
                    return false;
                }
                if ($ctrl.routes[i].seatsCount < +$ctrl.adults + +$ctrl.children) {
                    nf('Выберите диапозон мест побольше для маршрута №' + (i + 1));
                    return false;
                }
            } else {
                if ($ctrl.routes[i].car.freeSeatsCount < +$ctrl.adults + +$ctrl.children) {
                    nf('В вагоне недостаточно мест для пассажиров в маршруте №' + (i + 1));
                    return false;
                }
            }
        }
        return true;
    }

    function openSecondStep() {
        $ctrl.hasFemaleCars = false;

        $ctrl.routes.forEach(route => {
            if (route.carGroup.genderType === 'female') {
                $ctrl.hasFemaleCars = true;
            }
        });

        generatePassengers();

        let requireAddFields = false;

        let totalCost = 0;

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].train.detail.isObligativeElReg) {
                requireAddFields = true;
            }

            if ($ctrl.routes[i].withBedding !== false ||
                $ctrl.routes[i].carGroup.typeSlug != 'placcart' ||
                $ctrl.routes[i].train.timeInWay.hours >= 6) {
                $ctrl.routes[i].withBedding = true;
            }

            totalCost += $ctrl.routes[i].carGroup.tariff * $ctrl.passengers.length;
        }

        $ctrl.requireAddFields = requireAddFields;

        $ctrl.totalCost = totalCost;

        let hasTrainRoutes = true;

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].train.routes) {
                $ctrl.routes[i].train.distance = trainRoutesService.getDistance(
                    $ctrl.routes[i].depStation.code,
                    $ctrl.routes[i].arrStation.code,
                    $ctrl.routes[i].train.routes
                );
            } else {
                hasTrainRoutes = false;
            }
        }

        if (hasTrainRoutes) {
            $ctrl.step = 2;

            $timeout(() => {
                // $location.hash('second-step-header');
                $anchorScroll({yOffset: 100});
            }, 300);
        } else {
            $ctrl.distanceLoading = true;

            setTrainsDistance().then(function () {
                $ctrl.step = 2;
                $ctrl.distanceLoading = false;

                $timeout(() => {
                    // $location.hash('second-step-header');
                    $anchorScroll({yOffset: 100});
                }, 300);
            });
        }
    }

    function setTrainsDistance() {

        let defer = $q.defer();

        (function setTrainItemDistance(routeInd) {

            let route = $ctrl.routes[routeInd];

            if (route.train.routes) {

                route.train.distance = trainRoutesService.getDistance(
                    route.depStation.code,
                    route.arrStation.code,
                    route.train.routes
                );

                if (routeInd + 1 < $ctrl.routes.length) {
                    setTrainItemDistance(routeInd + 1);
                } else {
                    defer.resolve();
                }

            } else {
                trainRoutesService
                    .getTrainRoutes(route.depStation.code, route.depDate, route.train.number)
                    .then(
                        function (routes) {

                            route.train.routes = routes;

                            route.train.distance = trainRoutesService.getDistance(
                                route.depStation.code,
                                route.arrStation.code,
                                route.train.routes
                            );

                            if (routeInd + 1 < $ctrl.routes.length) {
                                setTrainItemDistance(routeInd + 1);
                            } else {
                                defer.resolve();
                            }

                        },
                        function () {
                            if (routeInd + 1 < $ctrl.routes.length) {
                                setTrainItemDistance(routeInd + 1);
                            } else {
                                defer.resolve();
                            }
                        }
                    );
            }

        })(0);

        return defer.promise;
    }

    $ctrl.setSeatsAllocations = function (routeInd, top, bottom) {
        $ctrl.routes[routeInd].allocationTop = top;
        $ctrl.routes[routeInd].allocationBottom = bottom;
    };

    $ctrl.setSeatsComp = function (routeInd, seatsComp) {
        $ctrl.routes[routeInd].seatsComp = seatsComp
    };

    $ctrl.setWithBedding = function (routeInd, withBedding) {
        $ctrl.routes[routeInd].withBedding = withBedding;
    };

    function generatePassengers() {

        setByType('adult');

        setByType('child');

        function setByType(type) {

            let currentCount = 0;

            for (let i = 0; i < $ctrl.passengers.length; i++) {
                if ($ctrl.passengers[i].type === type) {
                    currentCount++;
                }
            }

            let cnt = type === 'adult' ? +$ctrl.adults : +$ctrl.children;

            if (cnt > currentCount) {
                let diff = cnt - currentCount;
                for (let i = 0; i < diff; i++) {
                    $ctrl.passengers.push(getPassengerItem(type));
                }
            }

            if (cnt < currentCount) {
                let diff = currentCount - cnt;
                for (let i = 0; i < diff; i++) {
                    for (let j = $ctrl.passengers.length - 1; j >= 0; j--) {
                        if ($ctrl.passengers[j].type === type) {
                            $ctrl.passengers.splice(j, 1);
                            break;
                        }
                    }
                }
            }

        }

        function getPassengerItem(type) {

            let tariff = null;

            if (type === 'adult') {
                tariff = 'full';
            }

            if (type === 'child') {
                tariff = 'kid';
            }

            return {
                type,
                employeeId: null,
                citizenshipCode: null,
                docTypeCode: null,
                docNumber: null,
                iin: null,
                firstName: null,
                lastName: null,
                patronymic: null,
                birthDate: null,
                gender: null,
                tariff,
                phone: null,
                email: null,
                routesIssueFee: null,
                save: false,
            };
        }
    }

    $ctrl.bookAll = function () {

        if (!Auth.can('booking_module.book')) {
            nf('У вас недостаточно прав для данного действия');
            return;
        }

        if (!validatePassengers()) {
            return;
        }

        checkElRegPossible().then(function () {
            checkForDuplicates().then(function (continueBooking) {
                if (continueBooking) {
                    startBooking();
                }
            });
        });
    };

    function checkElRegPossible() {

        let defer = $q.defer();

        let notElRegRoutes = [];

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if (!$ctrl.routes[i].train.elRegPossible || !$ctrl.routes[i].car.elRegPossible) {
                notElRegRoutes.push($ctrl.routes[i]);
            }
        }

        if (notElRegRoutes.length) {
            $uibModal
                .open({
                    component: 'notElRegRoutes',
                    resolve: {
                        routes: function () {
                            return notElRegRoutes;
                        }
                    }
                })
                .result
                .then(
                    function () {
                        defer.resolve(true);
                    },
                    function () {
                        defer.resolve(false);
                    }
                );
        } else {
            defer.resolve(true);
        }

        return defer.promise;
    }

    function validatePassengers() {

        for (let i = 0; i < $ctrl.passengers.length; i++) {
            if ($ctrl.passengers[i].hasErrors) {
                nf(
                    'Исправьте ошибки по заполнению данных пассажира №' + (i + 1),
                    'alert-danger',
                    2000
                );
                return false;
            }
        }

        return true;
    }

    function startBooking() {

        $ctrl.step = 3;

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if (!$ctrl.routes[i].status || $ctrl.routes[i].status == 'waiting') {
                $ctrl.routes[i].status = 'waiting';
                $ctrl.routes[i].processStatus = null;
                $ctrl.routes[i].errorStatus = null;
            }
        }

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].status == 'waiting') {
                $ctrl.allBooking = true;
                bookItem(i, true, function () {
                    $ctrl.allBooking = false;
                    $ctrl.isEditing = false;
                });
                return;
            }
        }

    }

    function checkForDuplicates() {

        let n = nf('Идет проверка на дубликаты', 'alert-info');

        let defer = $q.defer();

        let tickets = [];

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].status && $ctrl.routes[i].status != 'waiting') {
                continue;
            }
            for (let j = 0; j < $ctrl.passengers.length; j++) {
                tickets.push({
                    route_ind: i,
                    passenger_ind: j,
                    dep_station_code: $ctrl.routes[i].depStation.code,
                    arr_station_code: $ctrl.routes[i].arrStation.code,
                    dep_date: $ctrl.routes[i].depDate,
                    first_name: $ctrl.passengers[j].firstName,
                    last_name: $ctrl.passengers[j].lastName,
                });
            }
        }

        $http
            .post('/orders/check-for-exists', {tickets: tickets})
            .then(
                function (response) {
                    n.close();
                    let tickets = response.data.tickets;
                    if (tickets.length) {
                        $uibModal
                            .open({
                                component: 'duplicatedTickets',
                                resolve: {
                                    passengers: function () {
                                        return $ctrl.passengers;
                                    },
                                    routes: function () {
                                        return $ctrl.routes;
                                    },
                                    tickets: function () {
                                        return tickets;
                                    }
                                }
                            })
                            .result
                            .then(
                                function () {
                                    defer.resolve(true);
                                },
                                function () {
                                    defer.resolve(false);
                                }
                            )
                    } else {
                        defer.resolve(true);
                    }
                },
                function (error) {
                    n.close();
                    notifier.errorResponseNotify(error);
                }
            );

        return defer.promise;
    }

    function generateBookParams(route) {

        let passengers = [];
        for (let i = 0; i < $ctrl.passengers.length; i++) {
            passengers.push({
                EmployeeId: $ctrl.passengers[i].employeeId,
                IIN: $ctrl.passengers[i].iin,
                TariffType: $ctrl.passengers[i].tariff,
                FirstName: $ctrl.passengers[i].firstName,
                LastName: $ctrl.passengers[i].lastName,
                Patronymic: $ctrl.passengers[i].patronymic,
                DocType: $ctrl.passengers[i].docTypeCode,
                DocNumber: $ctrl.passengers[i].docNumber,
                BirthDate: $ctrl.passengers[i].birthDate
                    ? moment($ctrl.passengers[i].birthDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                    : null,
                Citizenship: $ctrl.passengers[i].citizenshipCode,
                Gender: $ctrl.passengers[i].gender,
                PhoneNumber: '7' + $ctrl.passengers[i].phone,
                Email: $ctrl.passengers[i].email,
                RoutesIssueFee: $ctrl.passengers[i].routesIssueFee,
                Save: $ctrl.passengers[i].save,
                FieldValues: $ctrl.passengers[i].fieldValues,
            });
        }

        let seatsComp = null;

        if (route.seatsComp === 'kupe') {
            seatsComp = 0;
        }

        if (route.seatsComp === 'otsek') {
            seatsComp = 1;
        }

        return {
            DepartureStationCode: route.depStation.code,
            ArrivalStationCode: route.arrStation.code,
            TrainNumber: route.train.number,
            DepartureDatetime: route.train.depDate.format('YYYY-MM-DD\THH:mm:ss'),
            CarType: route.carGroup.typeNumber,
            CarClassService: route.carGroup.classServiceType,
            CarNumber: route.car.number,
            SeatsStart: route.seatsStart,
            SeatsEnd: route.seatsEnd,
            TopSeatsCount: route.allocationTop,
            BottomSeatsCount: route.allocationBottom,
            SeatsComp: seatsComp,
            WoBedding: !route.withBedding,
            CompType: null,
            CreditCard: true,
            AdditionalData: {
                MinPrice: route.train.minCost,
                MaxPrice: route.train.maxCost,
                Distance: route.train.distance,
            },
            ClientId: $ctrl.client ? $ctrl.client.id : null,
            ClientFieldValues: $ctrl.fields.map(field => {
                return {field_id: field.id, value: $ctrl.clientFieldValues[field.id] || null}
            }),
            Passengers: passengers,
            PaymentType: $ctrl.paymentType
        };
    }

    $ctrl.bookItem = function (ind) {
        if ($ctrl.routes[ind].processStatus) {
            nf('Now process is running');
            return;
        }
        if ($ctrl.routes[ind].status == 'waiting') {
            bookItem(ind, false);
        } else {
            nf('Not correct status for booking');
        }
    };

    function bookItem(routeInd, withNextRoute, endCallback) {

        let route = $ctrl.routes[routeInd];

        route.errorStatus = null;
        route.processStatus = 'booking';

        let params = generateBookParams(route);

        params['RouteInd'] = routeInd;

        $http
            .post('/railways-api/book', params)
            .then(
                function (response) {

                    route.status = 'booked';
                    route.processStatus = null;

                    route.mobiusOrderId = response.data.mobiusOrderId;
                    route.orderId = response.data.orderId;
                    route.tickets = response.data.tickets;

                    for (let i = 0; i < route.tickets.length; i++) {
                        $ctrl.passengers[i].id = route.tickets[i].passengerId;
                    }

                    route.confirmCountdown = 600;
                    route.confirmCountdownInterval = $interval(function () {
                        if (route.confirmCountdown == 0) {
                            $interval.cancel(route.confirmCountdownInterval);
                            return;
                        }
                        route.confirmCountdown--;
                    }, 1000);

                    emitOrderBooked(route);

                    after();
                },
                function (error) {

                    route.processStatus = null;

                    route.errorStatus = 'booking';
                    route.errorMessage = error.data.messages ? error.data.messages[0] : '';
                    route.errorCountdown = 30;
                    route.errorCountdownInterval = $interval(function () {
                        if (route.errorCountdown == 0) {
                            $interval.cancel(route.errorCountdownInterval);
                            return;
                        }
                        route.errorCountdown--;
                    }, 1000);

                    after();
                }
            );

        function after() {
            if (withNextRoute) {
                for (let i = routeInd + 1; i < $ctrl.routes.length; i++) {
                    if ($ctrl.routes[i].status == 'waiting') {
                        bookItem(i, true, endCallback);
                        return;
                    }
                }
            }
            if (endCallback) {
                endCallback();
            }
        }
    }

    $ctrl.cancelItem = function (ind) {

        if ($ctrl.routes[ind].processStatus) {
            nf('Now process is running');
            return;
        }

        if ($ctrl.routes[ind].status == 'booked') {
            cancelItem(ind, false);
        } else {
            nf('Not correct status for cancel');
        }

    };

    function cancelItem(routeInd, withNextRoute, endCallback) {

        let route = $ctrl.routes[routeInd];

        route.errorStatus = null;
        route.processStatus = 'cancel';

        $http
            .post('/railways-api/cancel', {orderId: route.orderId})
            .then(
                function () {
                    route.processStatus = null;
                    route.status = 'canceled';
                    if (route.confirmCountdownInterval) {
                        $interval.cancel(route.confirmCountdownInterval)
                    }
                    emitOrderCanceled(route);
                    after();
                },
                function (error) {

                    route.processStatus = null;

                    route.errorStatus = 'cancel';
                    route.errorMessage = error.data.messages[0];
                    route.errorCountdown = 30;
                    route.errorCountdownInterval = $interval(function () {
                        if (route.errorCountdown == 0) {
                            $interval.cancel(route.errorCountdownInterval);
                            return;
                        }
                        route.errorCountdown--;
                    }, 1000);
                    after();
                }
            );

        function after() {
            if (withNextRoute) {
                for (let i = routeInd + 1; i < $ctrl.routes.length; i++) {
                    if ($ctrl.routes[i].status == 'booked') {
                        cancelItem(i, true, endCallback);
                        return;
                    }
                }
            }
            if (endCallback) {
                endCallback();
            }
        }
    }

    $ctrl.issueAll = function () {

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].processStatus) {
                nf('Has in process route');
                return;
            }
            if ($ctrl.routes[i].status == 'sent-to-confirm') {
                nf('Has sent to confirm route');
                return;
            }
            if ($ctrl.routes[i].status == 'canceled') {
                nf('Has canceled order');
                return;
            }
        }

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].status == 'booked') {
                $ctrl.allIssue = true;
                $ctrl.sendToConfirmItem(i, true, function () {
                    $ctrl.allIssue = false;
                });
                return;
            }
        }
    };

    $ctrl.sendToConfirmItem = function (ind, withNextDir, endCallback) {

        if (!Auth.can('booking_module.confirm')) {
            nf('У вас недостаточно прав для данного действия');
            return;
        }

        if ($ctrl.routes[ind].status == 'booked' && $ctrl.routes[ind].confirmCountdown) {

            let route = $ctrl.routes[ind];

            route.processStatus = 'sent-to-confirm';
            route.errorStatus = null;

            $http
                .post('/railways-api/send-to-confirm', {
                    orderId: route.orderId
                })
                .then(
                    function (response) {
                        route.processStatus = null;
                        route.status = 'sent-to-confirm';
                        emitSentToConfirm(route);
                        after();
                    },
                    function (error) {
                        route.processStatus = null;
                        route.errorStatus = 'sent-to-confirm';
                        route.errorMessage = error.data.messages[0];
                        route.errorCountdown = 30;
                        route.errorCountdownInterval = $interval(function () {
                            if (route.errorCountdown == 0) {
                                $interval.cancel(route.errorCountdownInterval);
                                return;
                            }
                            route.errorCountdown--;
                        }, 1000);
                        after();
                    }
                );

        } else {
            nf('Not correct status for send to confirm');
        }

        function after() {
            if (withNextDir) {
                for (let i = ind + 1; i < $ctrl.routes.length; i++) {
                    if ($ctrl.routes[i].status == 'booked') {
                        $ctrl.sendToConfirmItem(i, withNextDir, endCallback);
                        return;
                    }
                }
            }
            if (endCallback) {
                endCallback();
            }
        }
    };

    console.log('Hello world');

    $ctrl.editItem = function (ind) {

        for (let i = 0; i < $ctrl.routes[ind].length; i++) {
            if ($ctrl.routes[i].processStatus) {
                nf('Now process is running');
                return;
            }
        }

        if ($ctrl.routes[ind].status == 'waiting') {

            if ($ctrl.routes.length > 1) {
                $ctrl.isEditing = true;
                $ctrl.editingRouteInd = ind;
            }

            console.log($ctrl.routes.length);

            $ctrl.step = 2;

        } else
        if ($ctrl.routes[ind].status == 'booked') {

            cancelItem(ind, false, function () {
                if ($ctrl.routes[ind].status == 'canceled') {
                    $ctrl.routes[ind].status = 'waiting';
                    $ctrl.isEditing = true;
                    $ctrl.editingRouteInd = ind;
                    $ctrl.step = 2;
                    if ($ctrl.routes.length == 1) {
                        $ctrl.isEditing = false;
                        $ctrl.editingRouteInd = null;
                    }
                }
            });

        } else {
            nf('Not correct status for edit');
        }

    };

    $ctrl.editAll = function () {

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].processStatus) {
                nf('Has in process route');
                return;
            }
            if ($ctrl.routes[i].status == 'sent-to-confirm') {
                nf('Has sent to confirm route');
                return;
            }
            if ($ctrl.routes[i].status == 'canceled') {
                nf('Has canceled order');
                return;
            }
        }

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].status == 'booked') {
                $ctrl.editingAll = true;
                cancelItem(i, true, function () {
                    $ctrl.editingAll = false;
                    after();
                });
                return;
            }
        }

        after();

        function after() {
            for (let i = 0; i < $ctrl.routes.length; i++) {
                if ($ctrl.routes[i].status == 'booked') {
                    return;
                }
            }
            for (let i = 0; i < $ctrl.routes.length; i++) {
                $ctrl.routes[i].status = 'waiting';
            }
            $ctrl.step = 2;
        }
    };

    $ctrl.searchClients = function (fragment) {
        return $http
            .get('/data/get-clients', {params: {search: fragment}})
            .then(
                function (response) {
                    const clients = response.data.clients;

                    clients.forEach(client => {
                        client.str = `${client.title} №${client.bin}`;
                    });

                    return clients;
                },
                function (error) {}
            );
    };

    $ctrl.clientSelected = function () {
        console.log('client selected');

        $ctrl.clientsCount = 1;

        $ctrl.fields.forEach(field => {
            if (field.pivot.edit_on_directory) {
                const fieldValue = $ctrl.client.field_values.find(v => v.field_id === field.id);

                if (fieldValue && fieldValue.value) {
                    if (field.type === 'numeric') {
                        $ctrl.clientFieldValues[field.id] = !isNaN(fieldValue.value) ? +fieldValue.value : null;
                    } else {
                        $ctrl.clientFieldValues[field.id] = fieldValue.value;
                    }
                } else if (field.pivot.default_value) {
                    if (field.type === 'numeric') {
                        $ctrl.clientFieldValues[field.id] = !isNaN(field.pivot.default_value) ? +field.pivot.default_value : null;
                    } else {
                        $ctrl.clientFieldValues[field.id] = field.pivot.default_value;
                    }
                }
            }
        });

        $ctrl.passengers.forEach(passenger => {
            passenger.employeeId = null;
            passenger.citizenshipCode = null;
            passenger.docTypeCode = null;
            passenger.docNumber = null;
            passenger.iin = null;
            passenger.lastName = null;
            passenger.firstName = null;
            passenger.patronymic = null;
            passenger.birthDate = null;
            passenger.gender = null;
            passenger.phone = null;
            passenger.email = null;
            passenger.hasErrors = false;
            passenger.save = false;
            passenger.routesIssueFee = [];
            passenger.fieldValues = [];
        });
    };

    function nf(message, className, duration) {
        return notify({
            message: message,
            classes: className || 'alert-danger',
            duration: duration || 0
        });
    }

    function generateOrder(route) {

        let tickets = [];

        for (let i = 0; i < $ctrl.passengers.length; i++) {
            tickets.push({
                passenger: {
                    first_name: $ctrl.passengers[i].firstName,
                    last_name: $ctrl.passengers[i].lastName,
                    patronymic: $ctrl.passengers[i].patronymic,
                    doc_number: $ctrl.passengers[i].docNumber,
                },
                express_id: route.tickets[i].expressId,
                sum: route.tickets[i].sum,
            });
        }

        return {
            id: route.orderId,
            dep_station: route.depStation.name,
            arr_station: route.arrStation.name,
            dep_datetime: route.train.depDate,
            arr_datetime: route.train.arrDate,
            train_number: route.train.number,
            is_talgo: route.train.type == 'talgo',
            car_type: route.carGroup.typeNumber,
            car_number: route.car.number,
            car_class_service: route.carGroup.classServiceType,
            confirm_countdown: 600,
            tickets: tickets,
        };
    }

    function emitOrderBooked(route) {

        let order = generateOrder(route);

        order.status = 'booked';

        let operation = {
            order: order,
            ticket: null,
            type: 'book',
            fail_message: null,
            added_on: new Date(),
            user: Auth.user,
            isLocal: true,
        };

        $rootScope.$emit('order.changed', operation);
    }

    function emitOrderCanceled(route) {

        let order = generateOrder(route);

        order.status = 'canceled';

        let operation = {
            order: order,
            ticket: null,
            type: 'cancel',
            fail_message: null,
            added_on: new Date(),
            user: Auth.user,
            isLocal: true,
        };

        $rootScope.$emit('order.changed', operation);

    }

    function emitSentToConfirm(route) {

        let order = generateOrder(route);

        order.status = 'booked';

        let operation = {
            order: order,
            ticket: null,
            type: 'send-to-confirm',
            fail_message: null,
            added_on: new Date(),
            user: Auth.user,
            isLocal: true,
        };

        $rootScope.$emit('order.changed', operation);
    }

    $rootScope.$on('order.changed', function (event, operation) {


        if (operation.isLocal) {
            return;
        }

        let order = operation.order;

        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].orderId == order.id) {
                if (operation.type == 'cancel' || operation.type == 'auto-cancel') {
                    $ctrl.routes[i].status = 'canceled';
                    $ctrl.routes[i].processStatus = null
                }
                if (operation.type == 'send-to-confirm') {
                    $ctrl.routes[i].status = 'sent-to-confirm';
                    $ctrl.routes[i].processStatus = null
                }
                if (operation.type == 'confirm-success') {
                    $ctrl.routes[i].status = 'confirmed';
                }
            }
        }

    });

    $rootScope.$on('activeOrders.sentToConfirm', function (event, data) {
        let orderId = data.orderId;
        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].orderId == orderId) {
                $ctrl.routes[i].processStatus = null;
                $ctrl.routes[i].status = 'sent-to-confirm';
            }
        }
    });

    $rootScope.$on('activeOrders.canceled', function (event, data) {
        let orderId = data.orderId;
        for (let i = 0; i < $ctrl.routes.length; i++) {
            if ($ctrl.routes[i].orderId == orderId) {
                $ctrl.routes[i].processStatus = null;
                $ctrl.routes[i].status = 'canceled';
            }
        }
    });

}

export default mod.name;



// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/booking-module/booking-module.js